import { defineComponent as _defineComponent } from 'vue'
import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import store from "@/store";
  import useVuelidate from "@vuelidate/core";
  import { minLength, maxLength, required } from "@vuelidate/validators";
  import { computed, onMounted, ref } from "vue";
  import { useRoute } from "vue-router";
  import dayjs from "dayjs";
  import { isLotOwner } from "@/helpers/lot/isLotOwner";
  import { LotInterface } from "@/types/LotInterface";
  import { Business } from "@/types/BusinessInterface";
  import { AxiosResponse } from "axios";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotNotes',
  props: {
    lot: {
      type: Object,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;
  const note = ref("");

  const route = useRoute();
  const lotId = computed(() => {
    return route.params.lotId;
  });

  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });

  const userBusiness = ref<Business | null>(null);
  const estate = computed(() =>
    store.state.user.landownerEstates.find((e) => e._id === estateId.value)
  );
  const canManageLot = computed(() =>
    isLotOwner(props.lot as LotInterface, userBusiness.value, estate.value)
  );

  const getUserBusiness = () => {
    store
      .dispatch("business/getBusinessByLandownerId")
      .then((res: AxiosResponse<Business>) => {
        userBusiness.value = res.data;
      });
  };

  onMounted(() => {
    getComments();
    getUserBusiness();
  });

  const comments = ref([]);
  const loading = ref(false);

  const getComments = () => {
    loading.value = true;
    store
      .dispatch("lot/getLotComments", {
        lotId: lotId.value,
        estateId: estateId.value,
      })
      .then((res) => {
        comments.value = res.data;
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const rules = {
    note: { required, minLength: minLength(3), maxLength: maxLength(1000) },
  };
  const v$ = useVuelidate(rules, { note }, { $lazy: true });

  const addNote = () => {
    v$.value.$touch();

    if (v$.value.$invalid) {
      return;
    }

    store
      .dispatch("lot/addLotComment", {
        estateId: estateId.value,
        lotId: lotId.value,
        text: note.value,
      })
      .then(() => {
        note.value = "";
        resetVuelidateErrors(v$);
        getComments();
      });
  };

  const deleteComment = (id: string) => {
    store
      .dispatch("lot/deleteLotComment", {
        commentId: id,
        estateId: estateId.value,
        lotId: lotId.value,
      })
      .then(() => {
        getComments();
      });
  };

  const idForEdit = ref("");
  const noteEdit = ref("");
  const rulesEdit = {
    noteEdit: { required, minLength: minLength(3), maxLength: maxLength(1000) },
  };
  const vEdit$ = useVuelidate(rulesEdit, { noteEdit }, { $lazy: true });

  function editComment(id: string, text: string) {
    idForEdit.value = id;
    noteEdit.value = text;
  }

  const confirm = () => {
    vEdit$.value.$touch();

    if (vEdit$.value.$invalid) {
      return;
    }

    store
      .dispatch("lot/updateLotComment", {
        estateId: estateId.value,
        commentId: idForEdit.value,
        text: noteEdit.value,
      })
      .then(() => {
        cancel();
        getComments();
      });
  };

  function cancel() {
    idForEdit.value = "";
    noteEdit.value = "";
  }

const __returned__ = { props, note, route, lotId, estateId, userBusiness, estate, canManageLot, getUserBusiness, comments, loading, getComments, rules, v$, addNote, deleteComment, idForEdit, noteEdit, rulesEdit, vEdit$, editComment, confirm, cancel, DropDown, get resetVuelidateErrors() { return resetVuelidateErrors }, get store() { return store }, get useVuelidate() { return useVuelidate }, get minLength() { return minLength }, get maxLength() { return maxLength }, get required() { return required }, computed, onMounted, ref, get useRoute() { return useRoute }, get dayjs() { return dayjs }, get isLotOwner() { return isLotOwner }, get LotInterface() { return LotInterface }, get Business() { return Business }, get AxiosResponse() { return AxiosResponse } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})